<template>
  <scroll-area class="work-area workarea">
    <template v-if="objectModelRelations.length">
      <base-object-model-relation
        v-for="objectModelRelation in objectModelRelations"
        :key="objectModelRelation.client_id"
        :object-model-relation="objectModelRelation"
        @remove="removeRelation">
      </base-object-model-relation>
    </template>
    <div v-else class="drop-in-zone empty">
      <p><b>Drag and Drop</b> relationship types here</p>
    </div>
    <template v-if="inverseObjectModelRelations.length">
      <h5>Relationships Defined in Other Object Models</h5>
      <base-object-model-relation
        v-for="relation in inverseObjectModelRelations"
        :key="relation.client_id"
        :object-model-relation="relation"
        disabled
      >
      </base-object-model-relation>
    </template>
  </scroll-area>
</template>

<script lang="ts">
  import Vue from "vue";
  import workareaDragMixin from "../../../common/mixins/drag/workareaDragMixin"
  import BaseObjectModelRelation from "./base-object-model-relation.vue";
  import ObjectModelRelation from "../../../common/models/objectModelRelations/objectModelRelation";
  import storeMapper from "../../../common/mixins/storeMappers/storeMapper";
  import {BuilderArea} from "../enums/builder-area";
  import ObjectModel from "../../../common/models/objectModel";
  import routerMixin from "../../../common/mixins/routerMixin";
  import selectedMixin from "../mixins/selectedMixin";

  const objectModelStoreMixin = storeMapper('objectModelStore', {state: ['objectModel']});

  export default Vue.extend({
    components: {
      BaseObjectModelRelation,
    },
    mixins: [
      workareaDragMixin,
      objectModelStoreMixin,
      routerMixin,
      selectedMixin,
    ],
    data: function () {
      return {
        draggableClasses: ['object-model-relation'],
        droppableClasses: ['object-model-relation', 'model-builder'],
        dragArea: BuilderArea.relationships,
      };
    },
    mounted() {
    },
    created() {
    },
    beforeDestroy() {
    },
    computed: {
      objectModelRelations(): ObjectModelRelation[] {
        return this.objectModel.objectModelRelationsArray;
      },
      inverseObjectModelRelations(): ObjectModelRelation[] {
        return this.objectModel.inverse_object_model_relations.all.filter(relatedObjectModelRelation => {
          // prevent circular relations from appearing in both sections
          return this.objectModelRelations.every(rel => rel.client_id !== relatedObjectModelRelation.client_id);
        });
      },
      targetRoot(): ObjectModel {
        return this.objectModel;
      }
    },
    methods: {
      removeRelation(relation: ObjectModelRelation): void {
        relation.destroy();
      }
    },
  });
</script>